/**
 * Extracts all `id` values from an array of objects into a Set.
 *
 * @param items - Array of objects with an `id` field of type string.
 * @returns A Set of unique string IDs.
 */
export function extractIds<T extends { id: string }>(items: T[]): Set<string> {
  return new Set(items.map(item => item.id));
}
